<template>
    <div>
        <div>
            <p class="text-center text-3xl color1"><i class="fa-solid fa-feather"></i> Yo me autovaluo</p>
            <p class="color1"><i class="fa-solid fa-circle-exclamation"></i> Seleccione como usted considere:</p>
            <div class="vx-row mt-5">
                <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-5/6 xl:w-5/6 mb-6">
                    <div class="vx-row" v-for="(item,key) in arrayQuestionsRubrica" :key="key">
                        <div class="vx-col w-full mb-6">
                            <div class="flex bg1" style="justify-content: space-between;">
                                <p class="bg1 titulo">Pregunta {{ key + 1 }}</p>
                                <!-- <p class="bg1 titulo">{{ item.puntaje }} pts</p> -->
                            </div>
                            <p class="mt-5 ml-2" style="font-weight: 400;">{{ item.indicador }}</p>
                            <!--opciones-->
                            <br>
                            <vs-divider></vs-divider>
                            <ul class="leftx ml-5">
                                <li class="my-3">
                                    <vs-radio :v-model="'pregunta'+item.id" @input="setSeleccion(item,1,key)" style="word-spacing: 1px;" :vs-name="'radios1'+item.id" :vs-value="item.opcion1">{{ item.opcion1 }}</vs-radio>
                                </li>
                                <li class="my-3">
                                    <vs-radio :v-model="'pregunta'+item.id" @input="setSeleccion(item,2,key)" style="word-spacing: 1px;" :vs-name="'radios1'+item.id" :vs-value="item.opcion2">{{ item.opcion2 }}</vs-radio>
                                </li>
                                <li class="my-3">
                                    <vs-radio :v-model="'pregunta'+item.id" @input="setSeleccion(item,3,key)" style="word-spacing: 1px;" :vs-name="'radios1'+item.id" :vs-value="item.opcion3">{{ item.opcion3 }}</vs-radio>
                                </li>
                                <li class="my-3">
                                    <vs-radio :v-model="'pregunta'+item.id" @input="setSeleccion(item,4,key)" style="word-spacing: 1px;" :vs-name="'radios1'+item.id" :vs-value="item.opcion4">{{ item.opcion4 }}</vs-radio>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <vs-divider></vs-divider>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/6 xl:w-1/6 mb-6">
                    <p class="text-center font-semibold color1">Preguntas</p>
                    <!--listado ul de preguntas arrayPreguntasRubrica-->
                    <ul class="leftx">
                        <li v-for="(item, key) in arrayQuestionsRubrica" :key="key" class="my-2">
                            <button @click="scrollTo(item.id)" :class="'tipo' + key + ' w-full colorbase'">
                                <i class="fa-regular fa-circle-question"></i> Pregunta {{ key + 1 }}
                            </button>
                        </li>
                    </ul>
                    <!--boton de finalizar evaluacion-->
                    <vs-button @click="openConfirmFinalizar()" class="w-full mt-5" type="gradient" color="success">Finalizar Rúbrica</vs-button>
                    <br>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    mapState
} from "vuex";
import GeneralMixin from "@/mixins/GeneralMixin.js";
export default {
    mixins: [GeneralMixin],
    data() {
       return{
            usuario:[],
            arrayQuestionsRubrica:[],
            arraySend:[],
       } 
    },
    props:{
        arrayPreguntasRubrica:{
            type: Array,
            default: []
        },
    },
    computed: {
        ...mapState(['setEvaluacion','setCalificacion'])
    },
    created(){
        let me = this
        me.usuario = JSON.parse(localStorage.getItem("usuario"))[0];
    },
    mounted(){
        let me = this
        me.arrayQuestionsRubrica = me.arrayPreguntasRubrica
        me.arraySend             = me.arrayPreguntasRubrica
    },      
    methods:{
        setSeleccion(item,opcion,tipo){
            let me = this
            //quitar la clase colorbase al boton tipo y agregar la clase colorSeleccionado con classlist y remove la clase colorbase
            let element = document.querySelector('.tipo'+tipo)
            element.classList.remove('colorbase')
            element.classList.add('colorSeleccionado')
            //con map
            me.arraySend.map((element) => {
                if(element.id == item.id){
                    element.opc1 = 0
                    element.opc2 = 0
                    element.opc3 = 0
                    element.opc4 = 0
                    element['opc'+opcion] = 1
                }
            })
        },
        openConfirmFinalizar(){
            //validar que exista un opc numero con valor 1
            let me = this
            let arrayEnviar = me.arraySend
            let arraySendFilter = arrayEnviar.filter(item => item.opc1 == 1 || item.opc2 == 1 || item.opc3 == 1 || item.opc4 == 1)
            if(arraySendFilter.length != arrayEnviar.length){
                this.$vs.notify({
                    title: 'Advertencia',
                    text: 'Debe seleccionar una opción en cada pregunta',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                })
                return
            }
            this.$vs.dialog({
                type: 'confirm',
                color: 'primary',
                title: 'Finalizar Evaluación',
                text: '¿Está seguro de finalizar la evaluación?',
                acceptText: 'Aceptar',
                accept: this.finalizarEvaluacion,
                cancelText: 'Cancelar',
                cancel: false
            })
        },
        finalizarEvaluacion(){
            let me = this
            let formData = new FormData();
            formData.append('arrayPreguntas',       JSON.stringify(me.arraySend))
            formData.append('id_evaluacion',        this.setEvaluacion.id);
            formData.append('id_estudiante',        this.usuario.idusuario);
            formData.append('saveEvaluacionRubrica','1')
            me.$vs.loading()
            this.$http.post(this.$server_url+'evaluacionRubrica', formData)
            .then(res => {
                this.$vs.loading.close()
                if(res.data.status == 0){
                    this.$vs.notify({
                        title: 'Error',
                        text: res.data.message,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                    return 
                }
                if(res.data.status == 500){
                    this.$vs.notify({
                        title: 'Error',
                        text: 'Error al finalizar la evaluación',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                    return
                }
                me.$vs.notify({
                    title: 'Éxito',
                    text: 'Rubrica finalizada con éxito',
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-check'
                })
                me.$emit('changeLoad',res.data)
            })
            .catch(err => {
                this.$vs.loading.close()
                this.$vs.notify({
                    title: 'Error',
                    text: 'Error al finalizar la evaluación',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                })
            })
        },
    }
}
</script>
<style scoped>
.color1{
    color:#2F68AD;
}
.titulo{
    font-size: 18px;
    color:#19467c;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: 600;
}
.tamanio1{
    font-size: 11px;
}
.bg1{
    background: #f1f2f3;
    padding: 8px;
}
.reloj{
    font-size: 16px;
    color: #2F68AD;
    text-shadow: #e3e5e7 1px 1px 1px;
    padding: 5px;
}
.colorbase{
    background: #f2f2f2;
    border: none;
    padding: 10px;
    border-radius: 10px;

}
.colorSeleccionado{
    background: #cc4d27;
    color:white;
    border: none;
    padding: 10px;
    border-radius: 10px;
}
.colorSeleccionado:hover{
    background: #ca6546;
    color:white;
    border: none;
    padding: 10px;
    border-radius: 10px;
}
</style>
